import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Hardware Module Service Stores
 */
export const hardwareStores: ServiceStoreConfig[] = [
  {
    name: "hardware-orders",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  // hardware-order-details service can be added when implemented
];